/**
 * People Master form validation (UI mock — client-side only).
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const MOBILE_RE = /^[6-9]\d{9}$/;
const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
/** Digits only (12) or grouped XXXX-XXXX-XXXX (same as vendor). */
const AADHAAR_RE = /^(\d{12}|\d{4}-\d{4}-\d{4}|XXXX-XXXX-\d{4})$/i;

export const FIELD_LIMITS = {
  name: { min: 2, max: 50 },
  fatherHusbandName: { min: 0, max: 50 },
  surname: { min: 0, max: 50 },
  mobile: { min: 10, max: 10 },
  email: { max: 100 },
  aadhaar: { max: 14 },
  pan: { max: 10 },
  electionCard: { max: 20 },
  drivingLicense: { max: 30 },
  educationDetails: { max: 250 },
  address1: { max: 120 },
  address2: { max: 120 },
  pin: { min: 6, max: 6 },
};

/** ISO date bounds for DOB picker (age ~18–100). */
export function dobMinIso() {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 100);
  return d.toISOString().slice(0, 10);
}

export function dobMaxIso() {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  return d.toISOString().slice(0, 10);
}

export function validatePeopleForm(form) {
  const errors = {};
  const name = String(form.name || '').trim();
  const father = String(form.fatherHusbandName || '').trim();
  const surname = String(form.surname || '').trim();
  const mobile = String(form.mobile || '').trim();
  const email = String(form.email || '').trim();
  const aadhaar = String(form.aadhaar || '').trim();
  const pan = String(form.pan || '').trim().toUpperCase();
  const pin = String(form.pin || '').trim();
  const dob = form.dob || '';

  if (!name) errors.name = 'First name is required';
  else if (name.length < FIELD_LIMITS.name.min)
    errors.name = `Min ${FIELD_LIMITS.name.min} characters`;
  else if (name.length > FIELD_LIMITS.name.max)
    errors.name = `Max ${FIELD_LIMITS.name.max} characters`;

  if (father.length > FIELD_LIMITS.fatherHusbandName.max)
    errors.fatherHusbandName = `Max ${FIELD_LIMITS.fatherHusbandName.max} characters`;

  if (surname.length > FIELD_LIMITS.surname.max)
    errors.surname = `Max ${FIELD_LIMITS.surname.max} characters`;

  if (!mobile) errors.mobile = 'Mobile is required';
  else if (!MOBILE_RE.test(mobile))
    errors.mobile = 'Enter a valid 10-digit Indian mobile';

  if (email) {
    if (email.length > FIELD_LIMITS.email.max)
      errors.email = `Max ${FIELD_LIMITS.email.max} characters`;
    else if (!EMAIL_RE.test(email)) errors.email = 'Enter a valid email address';
  }

  if (aadhaar) {
    if (!AADHAAR_RE.test(aadhaar))
      errors.aadhaar = 'Use 12 digits (XXXX-XXXX-XXXX)';
  }

  if (pan) {
    if (!PAN_RE.test(pan)) errors.pan = 'Invalid PAN (e.g. ABCDE1234F)';
  }

  if (String(form.electionCard || '').length > FIELD_LIMITS.electionCard.max)
    errors.electionCard = `Max ${FIELD_LIMITS.electionCard.max} characters`;

  if (String(form.drivingLicense || '').length > FIELD_LIMITS.drivingLicense.max)
    errors.drivingLicense = `Max ${FIELD_LIMITS.drivingLicense.max} characters`;

  if (String(form.educationDetails || '').length > FIELD_LIMITS.educationDetails.max)
    errors.educationDetails = `Max ${FIELD_LIMITS.educationDetails.max} characters`;

  if (String(form.address1 || '').length > FIELD_LIMITS.address1.max)
    errors.address1 = `Max ${FIELD_LIMITS.address1.max} characters`;

  if (String(form.address2 || '').length > FIELD_LIMITS.address2.max)
    errors.address2 = `Max ${FIELD_LIMITS.address2.max} characters`;

  if (!form.gender) errors.gender = 'Gender is required';

  if (!form.villageId) errors.villageId = 'Select village from Village Master';

  if (pin) {
    if (!/^\d{6}$/.test(pin)) errors.pin = 'PIN must be 6 digits';
  }

  if (dob) {
    if (dob > dobMaxIso()) errors.dob = 'Must be at least 18 years old';
    else if (dob < dobMinIso()) errors.dob = 'Date of birth is too far in the past';
  }

  return errors;
}
